<div class="header-feedback">
  <div class="header-feedback__header flex-row">
    <div class="header-feedback__header__title typography__h6 flex-centered" data-cy="feedback-header-title">
      {{ 'header.submit-feedback' | translate }}
    </div>

    <div class="header-feedback__header__close flex-centered" (click)="closeDialog()" data-cy="feedback-close">
      <mat-icon>close</mat-icon>
    </div>
  </div>

  <form [formGroup]="feedbackForm">
    <div class="header-feedback__content">
      <div class="header-feedback__content__category">
        <cm-select-box
          [dataCy]="'feedback-category'"
          [dataSource]="categories"
          [displayExpr]="displayExpr"
          [valueExpr]="displayExpr"
          [required]="true"
          [errorLocation]="'top'"
          [placeholder]="'header.category' | translate"
          [errors]="
            feedbackForm.controls.category.dirty
              ? feedbackForm.controls.category.errors
              : null
          "
          formControlName="category"
        ></cm-select-box>
      </div>

      <div class="header-feedback__content__feedback">
        <cm-text-field
          class="feedback-field"
          data-cy="feedback-field"
          mode="outline"
          formControlName="feedback"
          [rows]="3"
          [maxLength]="2000"
          [required]="true"
          [label]="'header.feedback' | translate"
          [hint]="'header.feedback-form-helper' | translate"
        ></cm-text-field>
      </div>

      <div class="header-feedback__content__file">
        <cm-file-upload
          type="profileImage"
          (fileChanged)="setFile($event)"
          (removeFile)="removeFile()"
          [fileSizeLimitMB]="fileUploadService.uploadSizeLimitMB"
          allowMultiple="true"
          [fileType]="'Profile'"
          [dataCy]="'feedback-image'"
        ></cm-file-upload>
      </div>
    </div>
  </form>

  <div class="header-feedback__footer">
    <cm-basic-button (click)="closeDialog()" color="primary" mode="flat" [dataCy]="'cancel-button'">
      {{ 'string.cancel' | translate }}
    </cm-basic-button>

    <cm-basic-button
      (clickEvent)="submitForm()"
      color="primary"
      mode="filled"
      [disabled]="feedbackForm.invalid || isLoading"
      [dataCy]="'save-button'"
    >
      {{ 'string.submit' | translate }}
    </cm-basic-button>
  </div>
</div>
